<form [formGroup]="form" (ngSubmit)="onSubmit()" class="soft-form auto-height no-padding">
  <div>
    <soft-validation-container
      [validation]="validation$ | async"
      class="soft-entity-validation"
    ></soft-validation-container>
  </div>

  <div class="flex flex-row justify-between top">
    <div class="fill-space">
      <label for="ticket#create_title" class="font-bold top required">{{
        '#TICKETS.CREATE.NAME' | translate
      }}</label>
      <soft-input
        type="text"
        id="ticket#create_title"
        placeholder="Betreff/Name"
        formControlName="name"
      />
      @if (form.controls['name'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'name'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>

    <div class="input-stack">
      <label for="ticket#create_type" class="font-bold top required">{{
        '#TICKETS.CREATE.TYPE' | translate
      }}</label>
      <soft-select formControlName="type" id="ticket#create_type">
        @for (ticketType of ticketTypes$ | async; track ticketType) {
          <soft-select-option
            [value]="ticketType"
            [id]="'ticket#create_type.' + ticketType.id"
            ><span [innerHTML]="ticketType.description"></span
          ></soft-select-option>
        }
      </soft-select>
      @if (form.controls['type'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'type'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
  </div>

  <div class="flex flex-row justify-between top mt-4">
    <div class="fill-space">
      <label for="ticket#create_description" class="font-bold top required">{{
        '#TICKETS.CREATE.DESCRIPTION' | translate
      }}</label>
      <soft-multiline-input
        id="ticket#create_description"
        [lines]="12"
        formControlName="description"
      ></soft-multiline-input>
      @if (form.controls['description'].touched) {
        <soft-validation-container
          [validation]="form | validationMessage: 'description'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>

    <div class="input-stack">
      <div class="relative">
        <span class="hint">{{ '#TICKETS.CREATE.PRIORITY_HINT' | translate }}</span>
        <label for="ticket#create_priority" class="font-bold top required">{{
          '#TICKETS.CREATE.PRIORITY' | translate
        }}</label>
        <soft-select formControlName="priority" id="ticket#create_priority">
          <soft-select-option *softRepeat="9; let i = index" [value]="i + 1"
            >{{ i + 1 }} -
            {{ '#TICKETS.PRIORITIES.' + (i + 1) | translate }}</soft-select-option
          >
        </soft-select>
        @if (form.controls['priority'].touched) {
          <soft-validation-container
            [validation]="form | validationMessage: 'priority'"
            class="soft-property-validation"
          ></soft-validation-container>
        }
      </div>

      <div class="mt-4">
        <label for="ticket#create_hotline" class="font-bold top">{{
          '#TICKETS.CREATE.HOTLINE' | translate
        }}</label>
        <soft-select formControlName="hotline" id="ticket#create_hotline">
          <soft-select-option [value]="null"></soft-select-option>
          @for (hotline of hotlines$ | async; track hotline) {
            <soft-select-option [value]="hotline"
              >{{ hotline.firstName }} {{ hotline.lastName }}</soft-select-option
            >
          }
        </soft-select>
      </div>
    </div>
  </div>

  <div class="flex flex-col soft-card mt-4 gap-3">
    <div class="flex items-center gap-2">
      <h4 class="font-bold">{{ '#TICKETS.CREATE.CONTACTS' | translate }}</h4>
      <div
        softToolTip="Teilnehmer hinzufügen"
        class="text-primary bg-primary-100 rounded-full p-3 cursor-pointer hover:bg-hover"
        (click)="changeContact(form.value.contacts)"
      >
        <soft-icon name="fa-regular fa-plus"></soft-icon>
      </div>
    </div>
    @if (form.value.contacts?.length > 0) {
      <div class="flex flex-col">
        @for (group of form.value.contacts || [] | groupBy: 'type'; track group) {
          <div class="flex flex-row gap-1 items-center">
            <h5 class="font-bold text-light">
              {{ $any(group).key | contactType | translate }}
            </h5>
            <div class="flex flex-row gap-1">
              @for (contact of group | toArray; track contact) {
                <soft-chip [canDelete]="true" (delete)="removeContact($any(contact))">
                  <strong>{{ $any(contact).contact.lastName }}</strong
                  >&nbsp;{{ $any(contact).contact.firstName }}
                </soft-chip>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="flex flex-col mt-4 soft-card">
    <h4 class="font-bold">{{ '#TICKETS.CREATE.DOCUMENTS' | translate }}</h4>
    <div class="flex flex-row card">
      <soft-file-input
        [selectionMode]="'multi'"
        id="ticket#create_files"
        formControlName="files"
        [progress]="(uploadState$ | async) ?? []"
      ></soft-file-input>
    </div>
  </div>
  <soft-validation-container
    class="soft-entity-validation"
    [validation]="validation$ | async"
  ></soft-validation-container>

  <div class="flex flex-row justify-end mt-2">
    <button
      type="submit"
      id="ticket#create_submit"
      [disabled]="form.invalid || loading()"
      class="soft-button primary rounded hover:cursor-pointer"
    >
      @if (loading()) {
        <i class="fa-regular fa-spinner fa-spin mr-2"></i>
      }
      {{ '#TICKETS.CREATE.SUBMIT' | translate }}
    </button>
  </div>
</form>
